import React, { useMemo } from 'react'
import Item from './Item';

function AllDetailList({ items, cardId, boardPermission }) {
  return (
    <>
      {items.map((item, idx) => (
        <Item
          item={item}
          key={`consolidate-card-item-${idx}`}
          cardId={cardId}
          boardPermission={boardPermission}
        />
      ))}
    </>
  );
}

export default React.memo(AllDetailList)
